(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-tease-popup"]) return;
  try {
    
      (() => {
        const popup = document.getElementById('TextTeasePopup');
        if (!popup || typeof popup.showModal !== 'function') return;
        if (window.__textTeasePopupInitialized) return;
        window.__textTeasePopupInitialized = true;

        const storageKey = 'text-tease-popup-dismissed-at';
        const subscribedKey = 'text-tease-popup-subscribed';
        const delay = Number(popup.dataset.delay || 4000);
        const dismissMinutes = Number(popup.dataset.dismissMinutes || 30);
        const isDesignMode = popup.dataset.designMode === 'true';
        const hasFormError = Boolean(popup.querySelector('[data-tt-form-error]'));
        const success = popup.querySelector('[data-tt-success]');
        const closeButton = popup.querySelector('[data-tt-close]');
        const generatorLink = popup.querySelector('[data-tt-generator]');

        const rememberDismissal = () => {
          try {
            localStorage.setItem(storageKey, String(Date.now()));
          } catch (error) {
            return;
          }
        };

        const closePopup = () => {
          rememberDismissal();
          popup.close();
        };

        const mayShow = () => {
          if (isDesignMode) return true;
          try {
            if (localStorage.getItem(subscribedKey) === 'true') return false;
            const dismissedAt = Number(localStorage.getItem(storageKey) || 0);
            return Date.now() - dismissedAt > dismissMinutes * 60000;
          } catch (error) {
            return true;
          }
        };

        closeButton?.addEventListener('click', closePopup);
        generatorLink?.addEventListener('click', rememberDismissal);
        popup.addEventListener('click', (event) => {
          if (event.target === popup) closePopup();
        });
        popup.addEventListener('cancel', (event) => {
          event.preventDefault();
          closePopup();
        });

        if (success) {
          try {
            localStorage.setItem(subscribedKey, 'true');
          } catch (error) {
            console.debug('Popup subscription preference could not be stored.');
          }
          popup.showModal();
          success.focus();
          return;
        }

        if (hasFormError) {
          popup.showModal();
          popup.querySelector('[aria-invalid="true"]')?.focus();
          return;
        }

        if (mayShow()) {
          window.setTimeout(() => popup.showModal(), isDesignMode ? 200 : delay);
        }
      })();
    
  } catch(e) { console.error(e); }
})();
})();
